exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.asterisk[data-v-90905c24]{color:#ff1414}li.li-cost[data-v-90905c24]{list-style:none}", ""]);

// exports
